module.exports = __webpack_public_path__ + "img/操作手册_03.203bab8c.svg";